/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ItemTraceabilityModel { 
    itemTraceabilityId?: number;
    itemNumber?: string | null;
    traceabilityIdentifier?: string | null;
    traceabilityMessage?: string | null;
    statusId?: number;
    createdTimeStamp?: string;
    modifiedTimeStamp?: string;
    createdByUserId?: number;
    modifiedByUserId?: number;
    statusDisplay?: string | null;
    createdByUserName?: string | null;
    modifiedByUserName?: string | null;
    readonly userNameDisplay?: string | null;
}

